import { render } from "./ChartTest.vue?vue&type=template&id=8103933e&lang=html"
import script from "./ChartTest.vue?vue&type=script&lang=js"
export * from "./ChartTest.vue?vue&type=script&lang=js"
script.render = render

export default script